/**
 * Formata um número de telefone brasileiro
 * @param value - String contendo o número de telefone
 * @returns String formatada ou "N/A" se a entrada for inválida
 */
export function formatPhone(value: string | null | undefined): string {
  if (!value || value.trim() === '') {
    return 'N/A';
  }

  let cleanValue = value.replace(/\D/g, '');

  if (cleanValue.length === 0) {
    return 'N/A';
  }
  if (cleanValue.startsWith('55') && cleanValue.length > 10) {
    cleanValue = cleanValue.substring(2);
  }

  if (cleanValue.length === 10) {
    return formatLandline(cleanValue);
  }

  if (cleanValue.length === 11) {
    return formatMobile(cleanValue);
  }

  return cleanValue;
}

/**
 * Formata um telefone fixo com a máscara (dd) 9999-9999
 * @param phone - String contendo 10 dígitos
 * @returns Telefone fixo formatado
 */
function formatLandline(phone: string): string {
  return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
}

/**
 * Formata um celular com a máscara (dd) 99999-9999
 * @param phone - String contendo 11 dígitos
 * @returns Celular formatado
 */
function formatMobile(phone: string): string {
  return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
}
